// extracted by mini-css-extract-plugin
export default {"isContainer":"embed_isContainer__1zSop","container":"embed_container__fiJBl","video":"embed_video__4GmlC","iframe":"embed_iframe__3xbds","videoIframe":"embed_videoIframe__2N25C"};